"use strict";
/**
 * Unless explicitly stated otherwise all files in this repository are licensed under the Apache-2.0 License.
 * This product includes software developed at Datadog (https://www.datadoghq.com/).
 * Copyright 2020-Present Datadog, Inc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyUsageAttributionValues = void 0;
/**
 * Fields in Usage Summary by tag(s).
 */
class MonthlyUsageAttributionValues {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return MonthlyUsageAttributionValues.attributeTypeMap;
    }
}
exports.MonthlyUsageAttributionValues = MonthlyUsageAttributionValues;
/**
 * @ignore
 */
MonthlyUsageAttributionValues.attributeTypeMap = {
    apiPercentage: {
        baseName: "api_percentage",
        type: "number",
        format: "double",
    },
    apiUsage: {
        baseName: "api_usage",
        type: "number",
        format: "double",
    },
    apmFargatePercentage: {
        baseName: "apm_fargate_percentage",
        type: "number",
        format: "double",
    },
    apmFargateUsage: {
        baseName: "apm_fargate_usage",
        type: "number",
        format: "double",
    },
    apmHostPercentage: {
        baseName: "apm_host_percentage",
        type: "number",
        format: "double",
    },
    apmHostUsage: {
        baseName: "apm_host_usage",
        type: "number",
        format: "double",
    },
    apmUsmPercentage: {
        baseName: "apm_usm_percentage",
        type: "number",
        format: "double",
    },
    apmUsmUsage: {
        baseName: "apm_usm_usage",
        type: "number",
        format: "double",
    },
    appsecFargatePercentage: {
        baseName: "appsec_fargate_percentage",
        type: "number",
        format: "double",
    },
    appsecFargateUsage: {
        baseName: "appsec_fargate_usage",
        type: "number",
        format: "double",
    },
    appsecPercentage: {
        baseName: "appsec_percentage",
        type: "number",
        format: "double",
    },
    appsecUsage: {
        baseName: "appsec_usage",
        type: "number",
        format: "double",
    },
    asmServerlessTracedInvocationsPercentage: {
        baseName: "asm_serverless_traced_invocations_percentage",
        type: "number",
        format: "double",
    },
    asmServerlessTracedInvocationsUsage: {
        baseName: "asm_serverless_traced_invocations_usage",
        type: "number",
        format: "double",
    },
    browserPercentage: {
        baseName: "browser_percentage",
        type: "number",
        format: "double",
    },
    browserUsage: {
        baseName: "browser_usage",
        type: "number",
        format: "double",
    },
    ciPipelineIndexedSpansPercentage: {
        baseName: "ci_pipeline_indexed_spans_percentage",
        type: "number",
        format: "double",
    },
    ciPipelineIndexedSpansUsage: {
        baseName: "ci_pipeline_indexed_spans_usage",
        type: "number",
        format: "double",
    },
    ciTestIndexedSpansPercentage: {
        baseName: "ci_test_indexed_spans_percentage",
        type: "number",
        format: "double",
    },
    ciTestIndexedSpansUsage: {
        baseName: "ci_test_indexed_spans_usage",
        type: "number",
        format: "double",
    },
    ciVisibilityItrPercentage: {
        baseName: "ci_visibility_itr_percentage",
        type: "number",
        format: "double",
    },
    ciVisibilityItrUsage: {
        baseName: "ci_visibility_itr_usage",
        type: "number",
        format: "double",
    },
    cloudSiemPercentage: {
        baseName: "cloud_siem_percentage",
        type: "number",
        format: "double",
    },
    cloudSiemUsage: {
        baseName: "cloud_siem_usage",
        type: "number",
        format: "double",
    },
    containerExclAgentPercentage: {
        baseName: "container_excl_agent_percentage",
        type: "number",
        format: "double",
    },
    containerExclAgentUsage: {
        baseName: "container_excl_agent_usage",
        type: "number",
        format: "double",
    },
    containerPercentage: {
        baseName: "container_percentage",
        type: "number",
        format: "double",
    },
    containerUsage: {
        baseName: "container_usage",
        type: "number",
        format: "double",
    },
    cspmContainersPercentage: {
        baseName: "cspm_containers_percentage",
        type: "number",
        format: "double",
    },
    cspmContainersUsage: {
        baseName: "cspm_containers_usage",
        type: "number",
        format: "double",
    },
    cspmHostsPercentage: {
        baseName: "cspm_hosts_percentage",
        type: "number",
        format: "double",
    },
    cspmHostsUsage: {
        baseName: "cspm_hosts_usage",
        type: "number",
        format: "double",
    },
    customEventPercentage: {
        baseName: "custom_event_percentage",
        type: "number",
        format: "double",
    },
    customEventUsage: {
        baseName: "custom_event_usage",
        type: "number",
        format: "double",
    },
    customIngestedTimeseriesPercentage: {
        baseName: "custom_ingested_timeseries_percentage",
        type: "number",
        format: "double",
    },
    customIngestedTimeseriesUsage: {
        baseName: "custom_ingested_timeseries_usage",
        type: "number",
        format: "double",
    },
    customTimeseriesPercentage: {
        baseName: "custom_timeseries_percentage",
        type: "number",
        format: "double",
    },
    customTimeseriesUsage: {
        baseName: "custom_timeseries_usage",
        type: "number",
        format: "double",
    },
    cwsContainersPercentage: {
        baseName: "cws_containers_percentage",
        type: "number",
        format: "double",
    },
    cwsContainersUsage: {
        baseName: "cws_containers_usage",
        type: "number",
        format: "double",
    },
    cwsHostsPercentage: {
        baseName: "cws_hosts_percentage",
        type: "number",
        format: "double",
    },
    cwsHostsUsage: {
        baseName: "cws_hosts_usage",
        type: "number",
        format: "double",
    },
    dbmHostsPercentage: {
        baseName: "dbm_hosts_percentage",
        type: "number",
        format: "double",
    },
    dbmHostsUsage: {
        baseName: "dbm_hosts_usage",
        type: "number",
        format: "double",
    },
    dbmQueriesPercentage: {
        baseName: "dbm_queries_percentage",
        type: "number",
        format: "double",
    },
    dbmQueriesUsage: {
        baseName: "dbm_queries_usage",
        type: "number",
        format: "double",
    },
    errorTrackingPercentage: {
        baseName: "error_tracking_percentage",
        type: "number",
        format: "double",
    },
    errorTrackingUsage: {
        baseName: "error_tracking_usage",
        type: "number",
        format: "double",
    },
    estimatedIndexedLogsPercentage: {
        baseName: "estimated_indexed_logs_percentage",
        type: "number",
        format: "double",
    },
    estimatedIndexedLogsUsage: {
        baseName: "estimated_indexed_logs_usage",
        type: "number",
        format: "double",
    },
    estimatedIndexedSpansPercentage: {
        baseName: "estimated_indexed_spans_percentage",
        type: "number",
        format: "double",
    },
    estimatedIndexedSpansUsage: {
        baseName: "estimated_indexed_spans_usage",
        type: "number",
        format: "double",
    },
    estimatedIngestedLogsPercentage: {
        baseName: "estimated_ingested_logs_percentage",
        type: "number",
        format: "double",
    },
    estimatedIngestedLogsUsage: {
        baseName: "estimated_ingested_logs_usage",
        type: "number",
        format: "double",
    },
    estimatedIngestedSpansPercentage: {
        baseName: "estimated_ingested_spans_percentage",
        type: "number",
        format: "double",
    },
    estimatedIngestedSpansUsage: {
        baseName: "estimated_ingested_spans_usage",
        type: "number",
        format: "double",
    },
    estimatedRumSessionsPercentage: {
        baseName: "estimated_rum_sessions_percentage",
        type: "number",
        format: "double",
    },
    estimatedRumSessionsUsage: {
        baseName: "estimated_rum_sessions_usage",
        type: "number",
        format: "double",
    },
    fargatePercentage: {
        baseName: "fargate_percentage",
        type: "number",
        format: "double",
    },
    fargateUsage: {
        baseName: "fargate_usage",
        type: "number",
        format: "double",
    },
    functionsPercentage: {
        baseName: "functions_percentage",
        type: "number",
        format: "double",
    },
    functionsUsage: {
        baseName: "functions_usage",
        type: "number",
        format: "double",
    },
    incidentManagementMonthlyActiveUsersPercentage: {
        baseName: "incident_management_monthly_active_users_percentage",
        type: "number",
        format: "double",
    },
    incidentManagementMonthlyActiveUsersUsage: {
        baseName: "incident_management_monthly_active_users_usage",
        type: "number",
        format: "double",
    },
    indexedSpansPercentage: {
        baseName: "indexed_spans_percentage",
        type: "number",
        format: "double",
    },
    indexedSpansUsage: {
        baseName: "indexed_spans_usage",
        type: "number",
        format: "double",
    },
    infraHostPercentage: {
        baseName: "infra_host_percentage",
        type: "number",
        format: "double",
    },
    infraHostUsage: {
        baseName: "infra_host_usage",
        type: "number",
        format: "double",
    },
    ingestedLogsBytesPercentage: {
        baseName: "ingested_logs_bytes_percentage",
        type: "number",
        format: "double",
    },
    ingestedLogsBytesUsage: {
        baseName: "ingested_logs_bytes_usage",
        type: "number",
        format: "double",
    },
    ingestedSpansBytesPercentage: {
        baseName: "ingested_spans_bytes_percentage",
        type: "number",
        format: "double",
    },
    ingestedSpansBytesUsage: {
        baseName: "ingested_spans_bytes_usage",
        type: "number",
        format: "double",
    },
    invocationsPercentage: {
        baseName: "invocations_percentage",
        type: "number",
        format: "double",
    },
    invocationsUsage: {
        baseName: "invocations_usage",
        type: "number",
        format: "double",
    },
    lambdaTracedInvocationsPercentage: {
        baseName: "lambda_traced_invocations_percentage",
        type: "number",
        format: "double",
    },
    lambdaTracedInvocationsUsage: {
        baseName: "lambda_traced_invocations_usage",
        type: "number",
        format: "double",
    },
    logsIndexed15dayPercentage: {
        baseName: "logs_indexed_15day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed15dayUsage: {
        baseName: "logs_indexed_15day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed180dayPercentage: {
        baseName: "logs_indexed_180day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed180dayUsage: {
        baseName: "logs_indexed_180day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed1dayPercentage: {
        baseName: "logs_indexed_1day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed1dayUsage: {
        baseName: "logs_indexed_1day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed30dayPercentage: {
        baseName: "logs_indexed_30day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed30dayUsage: {
        baseName: "logs_indexed_30day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed360dayPercentage: {
        baseName: "logs_indexed_360day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed360dayUsage: {
        baseName: "logs_indexed_360day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed3dayPercentage: {
        baseName: "logs_indexed_3day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed3dayUsage: {
        baseName: "logs_indexed_3day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed45dayPercentage: {
        baseName: "logs_indexed_45day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed45dayUsage: {
        baseName: "logs_indexed_45day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed60dayPercentage: {
        baseName: "logs_indexed_60day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed60dayUsage: {
        baseName: "logs_indexed_60day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed7dayPercentage: {
        baseName: "logs_indexed_7day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed7dayUsage: {
        baseName: "logs_indexed_7day_usage",
        type: "number",
        format: "double",
    },
    logsIndexed90dayPercentage: {
        baseName: "logs_indexed_90day_percentage",
        type: "number",
        format: "double",
    },
    logsIndexed90dayUsage: {
        baseName: "logs_indexed_90day_usage",
        type: "number",
        format: "double",
    },
    logsIndexedCustomRetentionPercentage: {
        baseName: "logs_indexed_custom_retention_percentage",
        type: "number",
        format: "double",
    },
    logsIndexedCustomRetentionUsage: {
        baseName: "logs_indexed_custom_retention_usage",
        type: "number",
        format: "double",
    },
    mobileAppTestingPercentage: {
        baseName: "mobile_app_testing_percentage",
        type: "number",
        format: "double",
    },
    mobileAppTestingUsage: {
        baseName: "mobile_app_testing_usage",
        type: "number",
        format: "double",
    },
    ndmNetflowPercentage: {
        baseName: "ndm_netflow_percentage",
        type: "number",
        format: "double",
    },
    ndmNetflowUsage: {
        baseName: "ndm_netflow_usage",
        type: "number",
        format: "double",
    },
    npmHostPercentage: {
        baseName: "npm_host_percentage",
        type: "number",
        format: "double",
    },
    npmHostUsage: {
        baseName: "npm_host_usage",
        type: "number",
        format: "double",
    },
    obsPipelineBytesPercentage: {
        baseName: "obs_pipeline_bytes_percentage",
        type: "number",
        format: "double",
    },
    obsPipelineBytesUsage: {
        baseName: "obs_pipeline_bytes_usage",
        type: "number",
        format: "double",
    },
    obsPipelinesVcpuPercentage: {
        baseName: "obs_pipelines_vcpu_percentage",
        type: "number",
        format: "double",
    },
    obsPipelinesVcpuUsage: {
        baseName: "obs_pipelines_vcpu_usage",
        type: "number",
        format: "double",
    },
    onlineArchivePercentage: {
        baseName: "online_archive_percentage",
        type: "number",
        format: "double",
    },
    onlineArchiveUsage: {
        baseName: "online_archive_usage",
        type: "number",
        format: "double",
    },
    profiledContainerPercentage: {
        baseName: "profiled_container_percentage",
        type: "number",
        format: "double",
    },
    profiledContainerUsage: {
        baseName: "profiled_container_usage",
        type: "number",
        format: "double",
    },
    profiledFargatePercentage: {
        baseName: "profiled_fargate_percentage",
        type: "number",
        format: "double",
    },
    profiledFargateUsage: {
        baseName: "profiled_fargate_usage",
        type: "number",
        format: "double",
    },
    profiledHostPercentage: {
        baseName: "profiled_host_percentage",
        type: "number",
        format: "double",
    },
    profiledHostUsage: {
        baseName: "profiled_host_usage",
        type: "number",
        format: "double",
    },
    rumBrowserMobileSessionsPercentage: {
        baseName: "rum_browser_mobile_sessions_percentage",
        type: "number",
        format: "double",
    },
    rumBrowserMobileSessionsUsage: {
        baseName: "rum_browser_mobile_sessions_usage",
        type: "number",
        format: "double",
    },
    rumReplaySessionsPercentage: {
        baseName: "rum_replay_sessions_percentage",
        type: "number",
        format: "double",
    },
    rumReplaySessionsUsage: {
        baseName: "rum_replay_sessions_usage",
        type: "number",
        format: "double",
    },
    sdsScannedBytesPercentage: {
        baseName: "sds_scanned_bytes_percentage",
        type: "number",
        format: "double",
    },
    sdsScannedBytesUsage: {
        baseName: "sds_scanned_bytes_usage",
        type: "number",
        format: "double",
    },
    serverlessAppsPercentage: {
        baseName: "serverless_apps_percentage",
        type: "number",
        format: "double",
    },
    serverlessAppsUsage: {
        baseName: "serverless_apps_usage",
        type: "number",
        format: "double",
    },
    siemIngestedBytesPercentage: {
        baseName: "siem_ingested_bytes_percentage",
        type: "number",
        format: "double",
    },
    siemIngestedBytesUsage: {
        baseName: "siem_ingested_bytes_usage",
        type: "number",
        format: "double",
    },
    snmpPercentage: {
        baseName: "snmp_percentage",
        type: "number",
        format: "double",
    },
    snmpUsage: {
        baseName: "snmp_usage",
        type: "number",
        format: "double",
    },
    universalServiceMonitoringPercentage: {
        baseName: "universal_service_monitoring_percentage",
        type: "number",
        format: "double",
    },
    universalServiceMonitoringUsage: {
        baseName: "universal_service_monitoring_usage",
        type: "number",
        format: "double",
    },
    vulnManagementHostsPercentage: {
        baseName: "vuln_management_hosts_percentage",
        type: "number",
        format: "double",
    },
    vulnManagementHostsUsage: {
        baseName: "vuln_management_hosts_usage",
        type: "number",
        format: "double",
    },
    workflowExecutionsPercentage: {
        baseName: "workflow_executions_percentage",
        type: "number",
        format: "double",
    },
    workflowExecutionsUsage: {
        baseName: "workflow_executions_usage",
        type: "number",
        format: "double",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=MonthlyUsageAttributionValues.js.map